import { get, writable } from 'svelte/store';
import { ButcherSectionService } from '../../services/butcher-section.service';
export const filterSectionId = writable(0);
export const loading = writable(false);
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList(sectionId) {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    filterSectionId.set(sectionId);
    await load();
    initDetail();
}
export async function initDetail() {
    record.set({
        oid: 0,
        sectionId: get(filterSectionId),
        workingYear: 0,
        workingMonth: 0,
        progressive: 0,
        dailyProgressive: 0,
        monthlyProgressive: 0,
        yearlyProgressive: 0,
        //livestockUnloadId: 0,
        lotNumber: '',
        //srcSlaughterId: 0,
        //srcProductTypeId: 0,
        srcQuantity: 0,
        srcWeight: 0,
        //dstProductTypeId: 0,
        dstQuantity: 0,
        dstWeight: 0,
        //recipeId: 0,
        //worked: 0,
        //printed: 0
    });
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _sectionId = get(filterSectionId);
        //let _pag = get(pagination)!;
        //let _resp = await ButcherSectionService.getButcherSectionItems(_sectionId, _pag.currentPage);
        let _resp = await ButcherSectionService.getButcherSectionItems(_sectionId);
        records.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
}
export function onEdit(item) {
    // console.log("onEdit", item);
    record.set(item.sectionItem);
}
export async function save() {
    let _record = get(record);
    return await ButcherSectionService.saveButcherSectionItem(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await ButcherSectionService.deleteButcherSectionItem(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
